import { getStaticImageUrl } from 'client/utils/image-helpers';

export const HERO_BG_PATHS = {
  lg: getStaticImageUrl('/type-page/roadGraphicsWithBg_lg.svg'),
  sm: getStaticImageUrl('/type-page/roadGraphicsWithBg_sm.svg'),
};

export const HERO_BG_PATHS_LAUREL = {
  lg: getStaticImageUrl('/type-page/gradientOnlygBgLg.svg'),
  sm: getStaticImageUrl('/type-page/laurelBgSm.svg'),
};
